import PropTypes from "prop-types"
import React from "react"
import TurtleImage from "./TurtleImage"
import HeaderLink from "./HeaderLink";
import "../../styles/header.css"
import "../../styles/HeaderLink.css"

const Header = () => (
  <header>
      <nav>
          <HeaderLink text="Jakub Wagner" link="/"/>
          <TurtleImage/>
          <HeaderLink text="Blog" link="/blog-page"/>
      </nav>
      <hr />
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
